module.exports = __webpack_public_path__ + "img/logo-sm.9eb28124.png";